
import {Component, Vue} from 'vue-property-decorator';
import RulesUtil from "@/util/rules";
import MasksUtil from "@/util/masks.util";
import EnderecoModel from '@/models/cliente/endereco.model';
import EnderecoService from "@/service/endereco.service";
import {namespace} from "vuex-class";
import {MapGettersCliente} from "@/store/modules/cliente/map-getters.cliente";
import DescricaoID from "@/models/lists/descricao-id.model";

const clienteStore = namespace('cliente');

@Component({
  name: "endereco-component"
})
export default class EnderecoComponent extends Vue {

  @clienteStore.Getter(MapGettersCliente.ID) id;

  private rules = RulesUtil;
  private masks = MasksUtil;
  private endereco = new EnderecoModel();
  private estados: Array<DescricaoID> = [];
  private idCliente = 0;

  async saveUpdateEndereco() {
    if ((this.$refs.formEndereco as HTMLFormElement).validate()) {
      const id_entidade = this.idCliente ? this.idCliente : this.id;
      this.endereco.id_entidade = id_entidade;
      if (this.endereco && this.endereco.id) {
        this.endereco = await EnderecoService.atualizar(this.endereco);
      } else {
        this.endereco = await EnderecoService.cadastrar(this.endereco);
      }
      const listEndereco: Array<EnderecoModel> = [this.endereco];
      this.$emit("retornoEndereco", listEndereco);
    }
  }

  nextStep(step: number) {
    this.$emit("nextStep", step);
  }

  async mounted() {
    const idRota: any = this.$route.params.id;
    if (idRota) {
      this.idCliente = idRota;
      let listaEndereco: Array<EnderecoModel> = await EnderecoService.buscarTodos(this.idCliente);
      if (listaEndereco.length > 0) {
        this.endereco = listaEndereco[0];
      }
    }
    this.estados = await EnderecoService.getEstados();
  }

}
